import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { dsClass } from '../../../../../common/constants/dsClasses.js';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { ModelType } from '../../../../../common/enums.js';
import { internetSubscriptionsMsg, omaElisaForCompaniesMsg, t } from '../../../../../common/i18n/index.js';
import { AnalyticsEventOrigins } from '../../../../../common/utils/analyticsUtils';
import { BreadCrumbsWithTitle } from '../../../../../components/BreadCrumbsWithTitle/BreadCrumbsWithTitle.js';
import { Grid } from '../../../../../components/Grid/Grid.js';
import { CardSelectionHeader } from '../../../../../components/OrderSubscriptionSelection/CardSelectionHeader.js';
import { Disclaimer } from '../../../../../components/OrderSubscriptionSelection/Disclaimer.js';
import { SubscriptionCardsByModelTypeWrapper } from '../../../../../components/OrderSubscriptionSelection/SubscriptionCardsByModelTypeWrapper.js';
import { applyWizardEvent } from '../../../../../selfservice/actions/index.js';
import { OrderSubscriptionSelectionHeader } from './OrderSubscription/OrderSubscriptionSelectionHeader.js';

export const BroadbandSubNewM2MPath = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(applyWizardEvent(1, 'NEW_MOBILE_M2M'));
  }, [dispatch]);

  return (
    <>
      <OrderSubscriptionSelectionHeader
        breadCrumbs={
          <BreadCrumbsWithTitle
            breadCrumbPaths={[
              { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
              { name: t.SEYV(internetSubscriptionsMsg), path: paths.PS_BROADBAND_SUBSCRIPTIONS },
              { name: t.A7CH('New Laitenetti subscription') },
            ]}
          />
        }
      />
      <Grid>
        <div className={`${dsClass.MARGIN_TOP_6} ${dsClass.PADDING_BOTTOM_7}`}>
          <CardSelectionHeader onlineModelType={ModelType.MobileM2M} />
        </div>
      </Grid>
      <SubscriptionCardsByModelTypeWrapper
        onlineModelType={ModelType.MobileM2M}
        eventOrigin={AnalyticsEventOrigins.OMAELISA}
      />
      <Grid>
        <Disclaimer />
      </Grid>
    </>
  );
};
